export const getJSONCheckSum = (json) => JSON.stringify(json);
